import { SEVERIDADES } from "../../lib/dashboard/tipos";

/*
 * Mapeamento de severidade → rótulo pt-BR e classe de cor (Tela 1).
 *
 * NÃO há tokens de cor próprios de severidade no CPMH (ver `tokens.css`): as
 * cores reusam os tokens semânticos existentes. Mapeamento (decisão do escopo
 * FE-1): critica → `text-erro`, alta/media → `text-aviso`, baixa/informativa →
 * `text-off-black`. Fonte ÚNICA — consumida por `AlertasBloco` e
 * `DiasDeRiscoTabela` para não divergirem.
 *
 * O backend pode, em tese, mandar uma severidade fora do catálogo; os fallbacks
 * (`?? chave`/`?? text-off-black`) garantem exibição sã sem quebrar.
 */

/** Rótulo pt-BR de cada severidade conhecida (deriva da tupla — fonte única). */
const ROTULO_SEVERIDADE: Record<string, string> = SEVERIDADES.reduce(
  (mapa, opcao) => {
    mapa[opcao.valor] = opcao.rotulo;
    return mapa;
  },
  {} as Record<string, string>,
);

/** Classe de cor (token CPMH) por severidade. */
const COR_SEVERIDADE: Record<string, string> = {
  critica: "text-erro",
  alta: "text-aviso",
  media: "text-aviso",
  baixa: "text-off-black",
  informativa: "text-off-black",
};

/** Rótulo pt-BR de uma severidade; severidade desconhecida → a própria chave. */
export function rotuloSeveridade(severidade: string): string {
  return ROTULO_SEVERIDADE[severidade] ?? severidade;
}

/** Classe de cor (token CPMH) de uma severidade; desconhecida → `text-off-black`. */
export function corSeveridade(severidade: string): string {
  return COR_SEVERIDADE[severidade] ?? "text-off-black";
}
